<template>
    <!-- Header -->
    <nav
        class="top-menu-box"
        :class="{'show': $store.state.showMobileMenu}">
        <button
            id="toggleMenu"
            class="navbar-toggler"
            type="button"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="toggleMobileMenu()">
            <span class="navbar-toggler-icon"></span>
        </button>
        <ul class="top-menu-box-left">
            <li><router-link :to="{name: 'AdditionalService'}" :alt="$t('global.menu.services_3pl')" :title="$t('global.menu.services_3pl')">{{ $t("global.menu.services_3pl") }}</router-link></li>
            <li><router-link :to="{name: 'Integration'}" :alt="$t('global.menu.services_ecommerce')" :title="$t('global.menu.services_ecommerce')">{{$t("global.menu.services_ecommerce")}}</router-link></li>
            <li><router-link :to="{name: 'Advantages'}" :alt="$t('global.menu.benefits')" :title="$t('global.menu.benefits')">{{$t("global.menu.benefits")}}</router-link></li>
            <li><router-link :to="{name: 'Prices'}" :alt="$t('global.menu.pricing')" :title="$t('global.menu.pricing')">{{$t("global.menu.pricing")}}</router-link></li>
        </ul>
        <div class="logo-box">
            <a :href="`${$t('meta.home.homeToUrl')}`">
                <img src="~img/logo.svg" :alt="$t('meta.home.h1')" :title="$t('meta.home.title')">
            </a>
        </div>
        <ul class="top-menu-box-right" :class="{'top-menu-box-right__auth': $store.getters.authorization}">
            <li><router-link :to="{name: 'Contacts'}" :alt="$t('global.menu.contacts')" :title="$t('global.menu.contacts')">{{$t("global.menu.contacts")}}</router-link></li>
            <template v-if="$store.getters.authorization">
                <li>
                    <router-link :to="{ name: 'UserPanel' }" :alt="$t('global.menu.profile')" :title="$t('global.menu.profile')">
                        <i class="icon-user"></i>
                        &nbsp;
                        <span v-html="$t('global.menu.profile')"></span>
                    </router-link>
                </li>
                <li>
                    <a @click="logout()" :alt="$t('global.menu.sign_out')" :title="$t('global.menu.sign_out')">
                        <i class="icon-signout"></i>
                        &nbsp;
                        <span v-html="$t('global.menu.sign_out')"></span>
                    </a>
                </li>
            </template>
            <template v-else>
                <li>
                    <router-link :to="{ name: 'login' }" :alt="$t('global.login')" :title="$t('global.login')">
                        <i class="icon-signout"></i>
                        &nbsp;
                        <span v-html="$t('global.menu.login')"></span>
                    </router-link>
                </li>
            </template>
        </ul>
    </nav>
    <!-- End Header -->
</template>
<script>
    export default {
        name: 'header-nav',

        data() {
            return {}
        },

        methods: {
            logout() {
                this.$store.commit('LOGOUT')
            },
            toggleMobileMenu() {
                this.$store.commit('SHOW_MOBILE_MENU_CHANGED', !this.$store.state.showMobileMenu)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue